module.exports = __webpack_public_path__ + "static/media/affiliate-program-present.8dbdf773.png";